import * as React from 'react'

const FullScreen = ({ strokeColor = 'white', className }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M1 4.75V1H4.75M1 9.25V13H4.75M9.25 13H13V9.25M13 4.75V1H9.25" stroke={strokeColor} strokeWidth="2" />
  </svg>
)

export default FullScreen
